<template>
  <v-app id="inspire">
    <v-overlay :value="overlay" z-index="10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <app-layout-drawer v-if="isAclLoad"/>
    <app-layout-bar/>
    <app-layout-content/>
    <app-layout-footer/>
  </v-app>
</template>

<script>
import tokenServices from '@/services/util/token';
import { mapActions, mapState } from 'vuex';
import { urlAuth } from '@/services/http/clientHttp';
import LayoutNavigationDrawer from './LayoutNavigationDrawer.vue';
import LayoutNavBar from './LayoutNavBar.vue';
import LayoutContent from './LayoutContent.vue';
import LayoutFooter from './LayoutFooter.vue';

export default {
  metaInfo: {
    title: 'Dashboard',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  components: {
    'app-layout-drawer': LayoutNavigationDrawer,
    'app-layout-bar': LayoutNavBar,
    'app-layout-content': LayoutContent,
    'app-layout-footer': LayoutFooter,
  },
  data: () => ({
    intervalRefresh: null,
    isAclLoad: false,
  }),
  mounted() {
    this.setOverlay(true);
    this.refreshToken();
    this.me()
      .then(() => {
        this.initAcl();
        this.setOverlay(false);
      })
      .catch(() => this.setOverlay(false));
  },
  beforeDestroy() {
    clearInterval(this.intervalRefresh);
  },
  computed: {
    ...mapState('app', ['overlay']),
    ...mapState('auth', ['authUser']),
  },
  methods: {
    initAcl() {
      const roles = this.authUser.perfis.map((r) => r.permissoes.map((p) => p.chave));
      this.$acl().setRoles(roles[0]);
      this.isAclLoad = true;
    },
    ...mapActions('app', ['setOverlay']),
    ...mapActions('auth', ['me']),
    refreshToken() {
      this.intervalRefresh = setInterval(() => {
        if (tokenServices.getTokenAuthorization()) {
          tokenServices.refreshToken();
        } else {
          window.location.replace(`${urlAuth}`);
        }
      }, 1000000);
    },
  },
};

</script>

<style lang="scss">
  @import '@/styles/index.scss';
</style>
